(function () {
  class ScreenShaker extends PIXI.Container {
    constructor() {
      super();

      this._active = false;

      this.orgOffsetSize = 2;
      this.offsetSize = this.orgOffsetSize;
    }

    initialise() {}

    init(itemsToShake) {
      this._itemsToShake = [];
      const self = this;
      itemsToShake.forEach(function (item) {
        self._itemsToShake.push({ item: item.item, isContainer: item.isContainer, orgX: 0, orgY: 0 });
      });
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
    }

    onOrientationChange() {
      if (this.isShaking() === true) {
        console.log('ScreenShaker- Stopping current shake due to onOrientationChange');
        this.stop();
      }
    }

    onResize() {
      if (this.isShaking() === true) {
        console.log('ScreenShaker- Stopping current shake due to resize');
        this.stop();
      }
      this.setOriginalCoordinates();
    }

    start() {
      Reflex.registerEventHandler('resize', this.onResize.bind(this));
      this.offsetSize = this.orgOffsetSize;
      this.getDirection = function () {
        return Math.floor(Math.random() * 4);
      };
      this._active = true;
      this.setOriginalCoordinates();
      this.shakeScreen();
    }

    stop() {
      this._active = false;
      timerManager.stop(this._timer);
      timerManager.stop(this._stopTimer);
      this.reset();
      Reflex.deregisterEventHandler('resize', this.onResize.bind(this));
    }

    setOriginalCoordinates() {
      this._itemsToShake.forEach(function (item) {
        if (item.isContainer) {
          item.orgX = item.item.x;
          item.orgY = item.item.y;
        } else {
          item.orgX = item.item.position.GetX();
          item.orgY = item.item.position.GetY();
        }
      });
    }

    reset() {
      this._itemsToShake.forEach(function (item) {
        if (item.isContainer) {
          item.item.x = item.orgX;
          item.item.y = item.orgY;
        } else {
          item.item.position.setX(item.orgX);
          item.item.position.setY(item.orgY);
        }
      });
    }

    shakeItems(xOffset, yOffset) {
      this._itemsToShake.forEach(function (item) {
        if (item.isContainer) {
          item.item.x = item.orgX + xOffset;
          item.item.y = item.orgY + yOffset;
        } else {
          item.item.position.setX(item.orgX + xOffset);
          item.item.position.setY(item.orgY + yOffset);
        }
      });
    }

    shakeScreen() {
      if (this._active) {
        const self = this;
        this._timer = timerManager.addTimer(
          10,
          function (progress) {},
          function () {
            const direction = self.getDirection();
            switch (direction) {
              case 0: {
                self.shakeItems(self.offsetSize, 0);
                break;
              }
              case 1: {
                self.shakeItems(-self.offsetSize, 0);
                break;
              }
              case 2: {
                self.shakeItems(0, self.offsetSize);
                break;
              }
              case 3: {
                self.shakeItems(0, -self.offsetSize);
                break;
              }
            }
            self._timer = timerManager.addTimer(
              10,
              function (progress) {},
              function () {
                self.reset();
                self.shakeScreen();
              }
            );
          }
        );
      } else {
        this.reset();
      }
    }

    blockLanded(blockSize) {
      timerManager.stop(this._timer);
      this._active = true;
      this.offsetSize = blockSize * 2;
      this.setOriginalCoordinates();

      this.getDirection = function () {
        return Math.floor(Math.random() * 2) + 2;
      };

      this.shakeScreen();

      const self = this;
      this._stopTimer = timerManager.addTimer(100, undefined, function () {
        self.stop();
      });
    }

    isShaking() {
      return this._active;
    }
  }

  var screenShakerCreator = function (json) {
    return new ScreenShaker();
  };

  var screenShakerInitialiser = function (json, screenShaker) {};

  var screenShakerFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    'screenShaker',
    screenShakerCreator,
    screenShakerInitialiser,
    screenShakerFilesRequired
  );
})();
